import React, { FC, useCallback, useState } from 'react'
import { useNavigate, useParams } from 'react-router'

import Page from '../../../components/Page'
import AuthShell from '../../../components/ui/AuthShell'
import NewPasswordForm, { NewPasswordState } from './NewPasswordForm'
import { handlePromise } from '../../../utils/handlePromisse'
import { newPassword } from '../../../services/authService'
import { useModal } from '../../../contexts/modal'
import MCAlert from '../../../components/ModalContents/MCAlert'

const CreateNewPassword: FC = () => {

  const params = useParams()
  const [loading, setLoading] = useState<boolean>(false)
  const { setModalContent, setModalOpen } = useModal()
  const navigate = useNavigate()

  const onSubmit = useCallback(async (values: NewPasswordState) => {
    if (params.token) {
      setLoading(true)
      const [, error] = await handlePromise(newPassword(params.token, values.password))
      if (error) {
        setModalContent(
          <MCAlert
            title="Erro ao criar nova senha"
            onClose={() => setModalOpen(false)}
          />
        )
        setModalOpen(true)
        setLoading(false)
        return
      }
      setModalContent(
        <MCAlert
          title="Senha alterada com sucesso"
          buttonText='IR PARA LOGIN'
          onClose={() => {
            setModalOpen(false)
            navigate('/login')
          }}
        />
      )
      setModalOpen(true)
      setLoading(false)
    }
  }, [params.token, setModalContent, setModalOpen, navigate])

  return (
    <Page title="Nova senha | ProAtivos">
      <AuthShell
        kicker="Segurança"
        title="Criar nova senha"
        subtitle="Defina uma nova senha para acessar a sua conta."
      >
        <NewPasswordForm onSubmit={onSubmit} loading={loading} />
      </AuthShell>
    </Page>
  )
}

export default CreateNewPassword
